import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { RestyledSecondaryButton } from '../styles';
var SecondaryButtonLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text/html' : _ref$type,
      buttonLinkProps = _objectWithoutProperties(_ref, ["children", "data-test", "type"]);

  return /*#__PURE__*/React.createElement(RestyledSecondaryButton, _extends({
    "data-test": dataTest ? dataTest : undefined,
    forwardedAs: "a",
    type: type,
    ref: ref
  }, buttonLinkProps), children);
});
SecondaryButtonLink.displayName = 'SecondaryButtonLink';
export default SecondaryButtonLink;